export const requestDataCinturon = (datos) => ({
  serialNumero: datos.serialNumero,
  nombre: datos.nombre,
  asiento: datos.asiento || "",
  activo: datos.activo ?? true,
  observacion: datos.observacion || "",
  empresasModel: {
    id: Number(datos?.empresasModel?.id ?? datos?.empresaId ?? 0),
  },
  vehiculosModel: datos?.vehiculosModel?.id || datos?.vehiculoId
    ? { id: Number(datos?.vehiculosModel?.id ?? datos?.vehiculoId) }
    : null,
  posicionModel: datos?.posicionModel?.id || datos?.posicionId
    ? { id: Number(datos?.posicionModel?.id ?? datos?.posicionId) }
    : null,
});
